import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const InfoCircleSmall = (props: SvgIconT.Props) => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <path d="M10.3 7.5h-2v1h1v4h-1v1h3v-1h-1zm-1-2h1v1h-1v-1zm.5-3a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15zm0 14c-3.584 0-6.5-2.916-6.5-6.5s2.916-6.5 6.5-6.5 6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5z"></path>
  </SvgIcon>
);

export default InfoCircleSmall;
